import { Inject, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(@Inject(Injector) private _injector: Injector) {
    // super(true);
  }
  private get _toastr(): ToastrService {
    return this._injector.get(ToastrService);
  }
  showSuccess(message, toasterPosition?: ToasterPosition): void {
    const config = {
      progressBar: true,
    };

    if (toasterPosition) {
      config['positionClass'] = toasterPosition;
    }
    this._toastr.success('', message, config);
  }
  showProgress(message, toasterPosition?: ToasterPosition): void {
    const config = {
      progressBar: true,
    };

    if (toasterPosition) {
      config['positionClass'] = toasterPosition;
    }
    this._toastr.info('', message, config);
  }
  showError(message, toasterPosition?: ToasterPosition): void {
    const config = {
      progressBar: true,
    };

    if (toasterPosition) {
      config['positionClass'] = toasterPosition;
    }
    this._toastr.error('', message, config);
  }
}

export enum ToasterPosition {
  topRight = 'toast-top-right',
  topLeft = 'toast-top-left',
  bottomRight = 'toast-bottom-right',
  bottomLeft = 'toast-bottom-left',
  topRightSticky = 'toast-top-right-sticky',
  // Other positions you would like
}
